export const DOMAIN_DEMO_NAME = 'pos.dev.eboxenterprises.com';
export const DOMAIN_DEMO1_NAME = 'river.pos.dev.studionovi.co';
export const DOMAIN_DEMO_NAME_API = 'api.dev.eboxenterprises.com';
export const DOMAIN_DEMO_API = 'https://'+DOMAIN_DEMO_NAME_API;

export const DOMAIN_INTERIM_NAME = 'pos.studionovi.com';
export const DOMAIN_INTERIM_NAME_API = 'api.studionovi.com';
export const DOMAIN_INTERIM_API = 'https://'+DOMAIN_INTERIM_NAME_API;